import { c as _c } from "react/compiler-runtime";
import DashboardPositionsCardSkeleton from '../../../DashboardPositionsCardSkeleton';
import DashboardEarnPositionsFilters from '../../DashboardEarnPositionsFilters';
import DashboardEarnPositionsTableRowsSkeleton from './DashboardEarnPositionsTableRowsSkeleton';
const DashboardEarnPositionsSkeleton = t0 => {
  const $ = _c(6);
  const {
    rows: t1
  } = t0;
  const rows = t1 === undefined ? 3 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DashboardEarnPositionsFilters disabled={true} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== rows) {
    t3 = <DashboardEarnPositionsTableRowsSkeleton rows={rows} />;
    $[1] = rows;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== rows || $[4] !== t3) {
    t4 = <DashboardPositionsCardSkeleton testId="dashboard-earn-positions-skeleton" filters={t2} rows={rows} mobileRows={t3} />;
    $[3] = rows;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default DashboardEarnPositionsSkeleton;